<script>
import ExpandableText from '@/components/general/expandable-text.vue'
import baseMixin from '@/mixins/baseMixin'

export default {
  components: {
    ExpandableText,
  },
  mixins: [baseMixin],
  props: {
    text: {
      type: String,
      default: '',
    },
  },
}
</script>

<template>
  <p class="opacity-7 mb-0">
    <slot></slot>
    <ExpandableText
      v-if="text.length"
      icon="mdi-comment-text-outline"
      :text="text"
    />
  </p>
</template>
